import React from 'react';
import { Box, Container, Typography, Link, Divider, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const pages = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Calendar', path: '/calendar' },
    { name: 'All Subscriptions', path: '/subscriptions' },
    { name: 'Add Subscription', path: '/add-subscription' },
    { name: 'Analytics', path: '/analytics' },
    { name: 'Profile', path: '/profile' },
    { name: 'Settings', path: '/settings' },
  ];

  const contactInfo = [
    { label: 'Email', value: 'app.gosublime@gmail.com', href: 'mailto:app.gosublime@gmail.com' },
    { label: 'Instagram', value: '@koderra.dev', href: 'https://instagram.com/koderra.dev' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #32CD32 0%, #20B2AA 50%, #87CEEB 100%)',
        borderTop: 1,
        borderColor: 'divider',
        mt: 'auto',
        py: 3,
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3}>
          {/* Main Footer Content */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 3,
            }}
          >
            {/* Logo and Description */}
            <Box>
              <Typography variant="h6" color="white" fontWeight="bold" gutterBottom>
                SubLime
              </Typography>
              <Typography variant="body2" color="rgba(255, 255, 255, 0.9)" maxWidth={300}>
                Smart subscription management for the modern digital lifestyle. 
                Track, manage, and optimize your recurring expenses.
              </Typography>
            </Box>

            {/* Pages Navigation */}
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom color="white">
                Pages
              </Typography>
              <Stack spacing={1}>
                {pages.map((page) => (
                  <Link
                    key={page.name}
                    component={RouterLink}
                    to={page.path}
                    color="rgba(255, 255, 255, 0.8)"
                    underline="hover"
                    sx={{
                      '&:hover': {
                        color: 'white',
                        textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    {page.name}
                  </Link>
                ))}
              </Stack>
            </Box>

            {/* Contact Information */}
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom color="white">
                Contact
              </Typography>
              <Stack spacing={1}>
                {contactInfo.map((contact) => (
                  <Box key={contact.label}>
                    <Typography variant="caption" color="rgba(255, 255, 255, 0.7)" display="block">
                      {contact.label}
                    </Typography>
                    <Link
                      href={contact.href}
                      color="rgba(255, 255, 255, 0.8)"
                      underline="hover"
                      sx={{
                        '&:hover': {
                          color: 'white',
                          textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                        },
                      }}
                    >
                      {contact.value}
                    </Link>
                  </Box>
                ))}
              </Stack>
            </Box>
          </Box>

          <Divider sx={{ borderColor: 'white' }} />

          {/* Copyright and Legal */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="body2" color="rgba(255, 255, 255, 0.9)">
              © {currentYear} SubLime. All rights reserved.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
